import React, { useEffect, useState } from "react";
import {
  Dialog,
  DialogTitle,
  DialogContent,
  TextField,
  Button,
  Stack,
  Typography,
  Grid,
  MenuItem,
} from "@mui/material";
import { useDispatch, useSelector } from "react-redux";
import {
  getCapability,
  getUserData,
  updateUserData,
} from "../Redux/UserDetails";
import { useMsal } from "@azure/msal-react";

const EditProfileDialog = ({
  open,
  onClose,
  user,
  capabilities,
  platform,
  photo,
}) => {
  const [unique, setUnique] = useState();
  const dispatch = useDispatch();

  const [form, setForm] = useState({
    name: user.name || "",
    role: user.role || "",
    level: user.level || "",
    enterpriseId: user.enterpriseId || "",
    platform: user.platform || "",
    capability: user.capability || "",
    industry: user.industry || "",
  });

  useEffect(() => {
    if (capabilities.length && user.capability) {
      setForm((prev) => ({
        ...prev,
        capability: user.capability,
      }));
    }
    if (platform) {
      setUnique([...new Set(platform.map((item) => item.Category))]);
    }
  }, [capabilities, user.capability, platform]);

  // const [photo, setPhoto] = useState(null);

  const handleChange = (e) => {
    setForm({ ...form, [e.target.name]: e.target.value });
  };

  const handleSave = () => {
    const formData = new FormData();

    formData.append("id", user.id);
    formData.append("enterpriseId", user.enterpriseId);
    formData.append("name", form.name);
    formData.append("role", form.role);
    formData.append("level", form.level);

    formData.append("platform", form.platform);
    formData.append("industry", form.industry);
    formData.append("capability", form.capability);

    formData.append("oldPhoto", user.photo || "");
    formData.append("businessUnit", user.businessUnit);

    if (photo) {
      formData.append("photo", photo);
    }

    dispatch(updateUserData(formData));
    onClose();
  };

  return (
    <DialogContent sx={{ padding: "0.5em 2em 0em 2em", color: "#555555" }}>
      <Grid container spacing={3} alignItems="center" mt={0}>
        {/* Role label */}
        <Grid item xs={12} md={6} sx={{ width: "100%" }}>
          <Typography sx={{ fontWeight: 700 }}>Details</Typography>
          <div
            style={{
              display: "grid",
              gridTemplateColumns: "47% 47%",
              justifyContent: "space-between",
              width: "100%",
              rowGap: "1em",
            }}
          >
            <Grid item xs={12}>
              <Typography
                variant="body2"
                sx={{ mb: 0.5, color: "#555555", fontWeight: "400" }}
              >
                Capability
              </Typography>
              <TextField
                select
                fullWidth
                variant="filled"
                value={form?.capability || ""}
                onChange={(e) =>
                  setForm({ ...form, capability: e.target.value })
                }
                slotProps={{
                  input: {
                    sx: {
                      "& .MuiFilledInput-input": {
                        padding: "5px",
                        color: "#99A1AF",
                      },
                      borderRadius: "0px",
                      fontSize: "0.85em",
                      borderTop: "2px grey solid",
                      borderRight: "2px grey solid",
                      borderLeft: "2px grey solid",
                    },
                  },
                }}
              >
                <MenuItem value="" disabled>
                  Select
                </MenuItem>
                {capabilities
                  .filter((item) => {
                    if (item.Capability === "Salesforce") {
                      return user?.businessUnit === "Salesforce";
                    }
                    return true;
                  })
                  .map((item) => (
                    <MenuItem
                      key={item.id || item.Capability}
                      value={
                        item.Capability === "Salesforce"
                          ? "Salesforce BG"
                          : item.Capability
                      }
                    >
                      {item.Capability === "Salesforce"
                        ? "Salesforce BG"
                        : item.Capability}
                    </MenuItem>
                  ))}
              </TextField>
            </Grid>

            {/* Level */}
            <Grid item xs={12}>
              <Typography
                variant="body2"
                sx={{ mb: 0.5, color: "#555555", fontWeight: "400" }}
              >
                Industry
              </Typography>
              <TextField
                select
                fullWidth
                variant="filled"
                value={form.industry}
                onChange={(e) => setForm({ ...form, industry: e.target.value })}
                slotProps={{
                  input: {
                    sx: {
                      "& .MuiFilledInput-input": {
                        padding: "5px",
                        color: "#99A1AF",
                      },
                      borderRadius: "0px",
                      fontSize: "0.85em",
                      borderTop: "2px grey solid",
                      borderRight: "2px grey solid",
                      borderLeft: "2px grey solid",
                    },
                  },
                }}
              >
                <MenuItem value="" disabled>
                  Select
                </MenuItem>

                {capabilities
                  // .filter(item => item.Capability === form.capability)
                  .map((item) => (
                    <MenuItem key={item.id} value={item.Industry}>
                      {item.Industry}
                    </MenuItem>
                  ))}
              </TextField>
            </Grid>

            <Grid item xs={12}>
              <Typography
                variant="body2"
                sx={{ mb: 0.5, color: "#555555", fontWeight: "400" }}
              >
                Platform
              </Typography>
              <TextField
                select
                fullWidth
                variant="filled"
                value={form.platform}
                onChange={(e) => setForm({ ...form, platform: e.target.value })}
                slotProps={{
                  input: {
                    sx: {
                      "& .MuiFilledInput-input": {
                        padding: "5px",
                        color: "#99A1AF",
                      },
                      borderRadius: "0px",
                      fontSize: "0.85em",
                      borderTop: "2px grey solid",
                      borderRight: "2px grey solid",
                      borderLeft: "2px grey solid",
                    },
                  },
                }}
              >
                <MenuItem value="" disabled>
                  Select
                </MenuItem>
                {unique &&
                  unique.map((item, index) => (
                    <MenuItem key={index} value={item}>
                      {item}
                    </MenuItem>
                  ))}
              </TextField>
            </Grid>

            {/* Level */}
            <Grid item xs={12}>
              <Typography
                variant="body2"
                sx={{ mb: 0.5, color: "#555555", fontWeight: "400" }}
              >
                Role
              </Typography>
              <TextField
                select
                fullWidth
                variant="filled"
                value={form.role}
                onChange={(e) => setForm({ ...form, role: e.target.value })}
                slotProps={{
                  input: {
                    sx: {
                      "& .MuiFilledInput-input": {
                        padding: "5px",
                        color: "#99A1AF",
                      },
                      borderRadius: "0px",
                      fontSize: "0.85em",
                      borderTop: "2px grey solid",
                      borderRight: "2px grey solid",
                      borderLeft: "2px grey solid",
                    },
                  },
                }}
              >
                <MenuItem value="" disabled>
                  Select
                </MenuItem>

                {platform
                  // .filter(item => item.Category === form.category)
                  .map((item) => (
                    <MenuItem key={item.id} value={item.Roles}>
                      {item.Roles}
                    </MenuItem>
                  ))}
              </TextField>
            </Grid>
          </div>
        </Grid>

        {/* Update button */}
        <Grid
          item
          xs={12}
          md={6}
          display="flex"
          justifyContent="center"
          sx={{ width: "100%" }}
        >
          <Button
            onClick={handleSave}
            sx={{
              backgroundColor: "#050505",
              color: "#fff",
              width: "12em",
              px: 3,
              py: 1.2,
              borderRadius: "6px",
              "&:hover": {
                backgroundColor: "#000",
              },
            }}
          >
            Update Profile
          </Button>
        </Grid>
      </Grid>
    </DialogContent>
  );
};

export default EditProfileDialog;
